import { StyleSheet, View, ViewProps } from "react-native";
import { ColorVariant, colors, radii } from "../utils/design";

const styles = StyleSheet.create({
  outerContainer: {
    padding: 1,
    borderRadius: radii[8],
  },

  container: {
    backgroundColor: colors.neutral[800],
    borderRadius: radii[8],
  },
});

type Props = {
  borderColor?: ColorVariant;
  children: React.ReactNode;
  style?: ViewProps["style"];
};

export const Tile = ({ borderColor, children, style }: Props) => {
  return (
    <View
      style={[
        styles.outerContainer,
        borderColor != null
          ? {
              backgroundImage: `linear-gradient(180deg, ${colors[borderColor][500]} 0%, transparent 100%)`,
            }
          : {
              backgroundColor: colors.neutral[700],
            },
      ]}
    >
      <View style={[styles.container, style]}>{children}</View>
    </View>
  );
};
